module.exports = __webpack_public_path__ + "img/product-2-girl.032dd32f.png";